/*
 * delivery-guard.js: makes sure every order goes through the cart page, where
 * customers pick their delivery window.
 *
 * Load it on every page (one line in layout/theme.liquid, see the README):
 *   - Any checkout button or link outside the cart page (the slide-out cart,
 *     popups, headers) sends the customer to the cart page instead.
 *   - Express buttons ("Buy it now", Shop Pay, Apple Pay, Google Pay) are
 *     hidden everywhere, because they jump straight to checkout and can't be
 *     intercepted. Customers can still pay with all of them inside checkout.
 */
(() => {
  const style = document.createElement("style");
  style.textContent = `
    .shopify-payment-button, shopify-accelerated-checkout, shopify-accelerated-checkout-cart,
    .additional-checkout-buttons, .cart__dynamic-checkout-buttons, [data-shopify="payment-button"],
    .dynamic-checkout__content { display: none !important; }
  `;
  document.head.appendChild(style);

  const onCartPage = /^\/cart\/?$/.test(location.pathname);
  if (onCartPage) return;   // delivery-cart.js handles checkout on the cart page itself

  const CHECKOUT = '[name="checkout"], a[href="/checkout"], a[href^="/checkout?"], ' +
                   'a[href*="/checkouts/"], [data-checkout], button[form="CartDrawer-Form"][name="checkout"]';

  document.addEventListener("click", (e) => {
    const el = e.target.closest(CHECKOUT);
    if (!el) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    location.href = "/cart";
  }, true);

  // Some themes submit a form straight to checkout without a click target.
  document.addEventListener("submit", (e) => {
    const form = e.target;
    const goingToCheckout = (e.submitter && e.submitter.name === "checkout") ||
      /\/checkout/.test(form.getAttribute("action") || "");
    if (!goingToCheckout) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    location.href = "/cart";
  }, true);
})();